export const getRuleEntitiesList = ({ ruleEntities }) =>
  ruleEntities.list.data.items;

export const getEntitiesIsListLoading = ({ ruleEntities }) =>
  ruleEntities.list.isLoading;
